import { SessionStorageKeys } from '@aglenergy/shared-library';
import { energyProductSearchApiService } from 'app/energy/services/energy-product-api.service';
import { CurrentSearchRequestModel, EnergySearchStore } from 'app/shared/models/current-search-request.model';
import { EnergyProductsResponse } from 'app/shared/models/product-response.model';
import { FuelType, SearchRequestType } from 'app/shared/models/energy/energy.enums';
import { ProductSearchRequestModel } from 'app/shared/models/productSearchRequestModel';
import { isSameAddress } from 'app/shared/utilities/address.util';

class EnergyProductSearchService {
  public async getProducts(searchRequest: CurrentSearchRequestModel): Promise<EnergyProductsResponse> {
    let result: EnergyProductsResponse;

    // Check the fuel type and default to dual if could not find.
    if (!searchRequest.productSearchRequestModel.fuelType) {
      searchRequest.productSearchRequestModel.fuelType = FuelType.Dual;
    }

    // Check response saved in store
    const responseInStore: EnergyProductsResponse = this.loadProductsResponseFromStore(searchRequest);
    if (responseInStore) {
      return responseInStore;
    }
    //Get Energy Products from API
    const response = await energyProductSearchApiService.getEnergyProducts(searchRequest.productSearchRequestModel);

    // Handle Energy Response
    if (response !== null) {
      result = response as EnergyProductsResponse;

      result = Object.assign(result, {
        isTariffUpdate: false,
        isRatesPeriodToggleUpdate: false
      });

      this.saveProductsInStore(searchRequest, result);
    }

    return result;
  }

  public loadProductsResponseFromStore(searchRequestModel: CurrentSearchRequestModel): EnergyProductsResponse | null {
    const request: ProductSearchRequestModel = searchRequestModel.productSearchRequestModel;
    const productsInStorage = (JSON.parse(sessionStorage.getItem(SessionStorageKeys.productSearchResponse)) ?? []) as EnergySearchStore[];
    if (productsInStorage?.length > 0) {
      // filter address search
      const foundRequest = productsInStorage.find((x: EnergySearchStore) => isSameAddress(x?.request?.productSearchRequestModel, request));
      if (foundRequest) {
        return foundRequest.response;
      }
    }
    return null;
  }

  public saveProductsInStore(requestModel: CurrentSearchRequestModel, response: EnergyProductsResponse): void {
    let productStore = new EnergySearchStore();
    const productsInStorage = (JSON.parse(sessionStorage.getItem(SessionStorageKeys.productSearchResponse)) ?? []) as EnergySearchStore[];

    if (productsInStorage?.length > 0) {
      const foundIndex = productsInStorage.findIndex((x: EnergySearchStore) =>
        isSameAddress(x?.request?.productSearchRequestModel, requestModel.productSearchRequestModel)
      );

      if (foundIndex >= 0) {
        productStore = productsInStorage[foundIndex];
        productsInStorage.splice(foundIndex, 1);
      }
    }

    // storing default tariff for elec
    if (response) {
      if (requestModel.selectedTariff.length === 0 && response.electricity && response.electricity.products.length > 0) {
        if (requestModel.searchRequestType === SearchRequestType.postcode || response.electricity.siteData.isDefaultRate) {
          requestModel.selectedTariff = 'Single Rate';
        } else {
          const productWithEstimate = response.electricity.products.find((prod) => prod.priceEstimates && prod.priceEstimates.length > 0);
          if (productWithEstimate) {
            requestModel.selectedTariff = productWithEstimate.priceEstimates[0].tariffDescription;
          }
        }
      }
    }

    productStore.request = requestModel;
    productStore.requestDateTime = new Date();
    productStore.response = response;
    productsInStorage.unshift(productStore);

    sessionStorage.setItem(SessionStorageKeys.productSearchResponse, JSON.stringify(productsInStorage));
  }

  public setRequestModel(requestModel: CurrentSearchRequestModel, energyResponse: EnergyProductsResponse): CurrentSearchRequestModel {
    if (requestModel.selectedTariff.length === 0 && energyResponse.electricity && energyResponse.electricity.products.length > 0) {
      if (requestModel.searchRequestType === SearchRequestType.postcode || energyResponse.electricity.siteData.isDefaultRate) {
        requestModel.selectedTariff = 'Single Rate';
      } else {
        const productWithEstimate = energyResponse.electricity.products.find(
          (prod) => prod.priceEstimates && prod.priceEstimates.length > 0
        );
        if (productWithEstimate) {
          requestModel.selectedTariff = productWithEstimate.priceEstimates[0].tariffDescription;
        }
      }
    }
    return requestModel;
  }
}

export const energyProductSearchService = new EnergyProductSearchService();
